import { api } from 'utility';
import { getUserActivityUrl } from 'URLs';
// Cards
export function getActivityLog(params) {
  return api.get(getUserActivityUrl(), { params }).then((res) => res.data);
}

export default {
  getActivityLog,
};
